module.exports = __webpack_public_path__ + "img/micron.36009701.jpg";